/**
 * Script globlal js doit contenir les scripts Js utilisés sur toutes les pages du site
 * - ce script est appelé directement par  les templates du site
 */

import "./custom-Jquery";
import '../node_modules/magnific-popup'; // Gestion des popup
import '../node_modules/slick-carousel/slick/slick'; // Gestion des carousels
import "./tagmanager"
import "./cookie-consent"

import "./home" // Js de la home
import "./form-tarifs" // Js Formulaire Tarifs
import "./form-demande-prof" // Js Formulaire demande Prof
import "./form-postuler" // Js Formulaire postuler
import "./form-mon-rendez-vous" // Js Formulaire monrendezvous
import "./form-stage" // Js Formulaire postuler
   
/**
 * Objet Completude + gestion de la validation
 */
(function(w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({},w.Completude, {
              
        /**
         * Met à disposition un Array contenant les ID des nouvelles agences 
         * configuré dans la page option d'ACF : /wp-admin/admin.php?page=completude-config
         * 
         * → voir completude_global_nouvelle_agence() dans function.php
         */
         settings : settings
    });


    /**
     * Initialise les composants HTML ( accordéon ...)
     */
    w.Completude.InitHtmlComponent = function() 
    {
      // Link accordeon
      jQuery('.link-accordion-expander').each(function () {
        $(this).off('click');
        $(this).on('click', function (event) {
            event.preventDefault();
            var $this = $(this);            
            $this.toggleClass('active');
            var $target = $this.data('target');
            $($target).toggleClass('expand');//.stop(true).slideFadeToggle(400);            
        });
      });

      //poppup
      $('.js-popup-init').magnificPopup({
        type: 'inline'
      });

      $('.js-popup-ajax-init').on('click', function() {
        $.magnificPopup.open({
          type: 'iframe',
          closeMarkup: '<button title="Fermer" type="button" class="mfp-close">x</button>',
          items: {
              src: $(this).data('target') + '?isIframe=true'
          },
          callbacks: {
              beforeAppend: function () {
                  this.content.find('iframe').on('load', function () {
                      $(".mfp-close").prependTo(".mfp-content");
                      initCloseElement();
                  });
              }
          },
          markup: '<style>.mfp-iframe-holder .mfp-content {max-width: 900px;height:100%}</style>' +
              '<div class="mfp-iframe-scaler">' +
              '<iframe class="mfp-iframe" frameborder="0" allowfullscreen scrolling="no" height="400" width="100%"></iframe>' +
              '</div></div>'
      })
    }
      );
      
      // Gestion des onglets      
      $('.tabs__nav a').on('click', function (event) {
          event.preventDefault();

          var $tabLink = $(this);
          var $targetTab = $($tabLink.data('target'));

          $tabLink
              .parent()
              .add($targetTab)
              .addClass('current')
              .siblings()
              .removeClass('current');
      });
    }
  
    /**
     * Retourne un objet contenant les champs utm_source,utm_content,utm_medium, utm_campaign, utm_term
     */
    w.Completude.GetGlobalUtmFields =function() {
       var data = {}
       try {
        var analyticsDatas = w.Completude.GetStorage('completude-analytics');
        if (analyticsDatas) {            
            return {
              UtmSource : analyticsDatas.utm_source,
              UtmContent : analyticsDatas.utm_content,
              UtmMedium : analyticsDatas.utm_medium,
              UtmTerm : analyticsDatas.utm_term,
              UtmCampaign : analyticsDatas.utm_campaign,
              clickid : analyticsDatas.clickid,
              clicksource : analyticsDatas.clicksource              
            };
        }
      } catch(e) {
        console.warn("Erreur in methode GetGlobalFields");
      }
      return data;
    };

    /**
     * Function qui capte les paramètres d'url global
     *  - agence par défaut 
     *  - utm
     *  - gclid
     */
    w.Completude.GetGlobalQueryParameter = function() {
      var queryParams = this.GetQueryParameters();
    var analyticsKeys = ['utm_source','utm_campaign','utm_term','utm_medium','utm_content'];
    var analyticsVars = w.Completude.GetStorage('completude-analytics') | {};
    var enregistreranalyticsVar = false;
    try {
        jQuery.each(queryParams, function (key, value) {
        if (jQuery.inArray(key, analyticsKeys) > -1) {
            // Si un des utm est présent, on enregistre la variable
            if (enregistreranalyticsVar==false) {
                enregistreranalyticsVar=true;
                analyticsVars = {};
            }
            analyticsVars[key] = value;
        }        
        if( key=='gclid' && enregistreranalyticsVar) {
            //  Click id google            
            analyticsVars['clickid'] = value;            
            analyticsVars['clicksource'] = 'google';            
        }
        else if(key=='msclkid' && enregistreranalyticsVar) {
            //  Click id google
            analyticsVars['clickid'] = value;
            analyticsVars['clicksource'] = 'bing';            
        }
        else if (key== 'clickid' && enregistreranalyticsVar) {
            // Click id autre (ex: talent.com)            
            analyticsVars['clickid'] = value;
            analyticsVars['clicksource'] = Completude.GetParameterByName("utm_source");            
        }
        });

        if (enregistreranalyticsVar) {        
            w.Completude.SetStorage('completude-analytics',analyticsVars);            
        }    
       
    }
    catch (e) {
        console.warn("Erreur in GetGlobalQueryParameter");
    }
    };

    /**
     * Retourne un tableau paramètre :
     * ex Completude.GetQueryParameters("utm_source=toto&utm_content=dddd");
     * -->  {utm_source: 'toto', utm_content: 'dddd'}
     * @param {clé du paramètre} str 
     */
    w.Completude.GetQueryParameters = function (str) {
      var result = (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) {
          return n = n.split("="), this[n[0]] = n[1], this
      }.bind({}))[0];
      if ('object' == typeof result) {
          jQuery.each(result, function (key, value) {
              result[key] = encodeURI(value);
          });
      }
  
      return result;    
    }

    /**
     * Retourne la valeur d'un parametre de l'url :
     * Ex :   Completude.GetParameterByName('utm_source')
     * -->   retourne   "google"
     * @param {nom du paramètre} name
     */
    w.Completude.GetParameterByName = function (name) {
      var url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

    /**
     * Retourne la valeur d'un cookie
     * @param {cookie name} cname 
     */
    w.Completude.GetCookie = function(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    /**
     *  Affecte un cookie
     * @param {Cookie name} cname 
     * @param {Cookie value} cvalue 
     * @param {Expiration en jour} exdays 
     */
    w.Completude.SetCookie = function (cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    /**
     * Retourne true si la chaine commence par une voyelle
     */
     w.Completude.beginsWithVowel =function (word) {
      return ['a', 'e', 'i', 'o', 'u'].indexOf(word[0].toLowerCase()) !== -1;
    }
    
    /**
     * Retourne une promise avec les infos de l'agence
     *  - retourne les infos stockées dans le session storage (ne pas les stocker dans le localstorage car pas de mise à jour en cas de changement) 
     *  - ou effectue une requete ajax pour obtenir les infos
     */
    w.Completude.GetAgency = function(id) {      
      if ((typeof(id) === 'undefined' && typeof(window.Completude.agence)!=='undefined') || (typeof(window.Completude.agence)!=='undefined' && window.Completude.agence && id==window.Completude.agence.Id)) {
        // Agence dans la variable globale
        return new Promise(function (resolve) {
          resolve(window.Completude.agence);
        });        
      }      
      else if ((typeof(id) === 'undefined' && window.sessionStorage.getItem('agence')) || (window.sessionStorage.getItem('agence') && w.Completude.GetStorage('agency_id')==id)) {
          // Agence stockée dans le session storage (une page avec un contexte agance a déjà été vue lors de la session)
          return new Promise(function (resolve) {
          resolve(JSON.parse(window.sessionStorage.getItem('agence')));
        });        
      }
      else if (typeof(id) === 'undefined' && typeof(window.Completude.agence)==='undefined' && !w.Completude.GetStorage('agency_id')) {
        // Pas d'agence et pas d'id agence sauvegardé dans le local storage
        return new Promise(function (resolve) {
          resolve(null);
        });        
      }
      else {
        if (typeof(id) === 'undefined' && w.Completude.GetStorage('agency_id')) {
          id = w.Completude.GetStorage('agency_id');
        }
        // l'id est définit et non connu
        // Chargement ajax de l'agence
        return new Promise(
          function (resolve) {
          jQuery.ajax({
          url: disko_ajax_object.ajaxurl,
          type: 'get',
          data: {
            'action': 'wp_get_agency',
            'id': id
          },
          dataFilter: function (response) {
            response = JSON.parse(response);
            if (response.success) {
              return response.data;
            }
          
            return false;
          },
          success: function (agency) {
            if (agency) {
              window.Completude.agence = agency;
              window.localStorage.setItem('agency_id',agency.Id)
              window.sessionStorage.setItem('agence', JSON.stringify(agency));                            
              resolve(agency);
            }
          }        
        }) // Fin promise
        });

      }
    }

    /**
     *  Retourne true ou false selon que l'agence est ouverte ou fermée
     * @param {} horaires 
     */
    w.Completude.isCompletudeOpen =  function(agence) {          
          try {           
          var now = new Date();                    
          if (agence !== null) {
              // une agence est passée en paramètre
              var horaire = null;            
              switch(now.getDay()){
                case 0 : 
                  //fermé
                  return false;
                case 1 :
                  horaire = agence.HoraireLundi;break;
                case 2 :
                  horaire = agence.HoraireMardi;break;
                case 3 :
                  horaire = agence.HoraireMercredi;break;
                case 4 :
                  horaire = agence.HoraireJeudi;break;
                case 5 :
                  horaire = agence.HoraireVendredi;break;
                case 6 :
                  horaire = agence.HoraireSamedi;break;
              }
              if (horaire!=null) {
                  // Un horaire est définit
                  var startend = horaire.split('-');
                  var start = startend[0];
                  var end = startend[1];
                  var timeStart =  new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0);
                  timeStart.setMinutes(+start*60);
                  var timeEnd = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0);
                  timeEnd.setMinutes(+end*60);
                  return now>timeStart && now <timeEnd;
              }
          }         
          if(now.getDay()==0 ) {
              //Dimanche = Fermé
              return false;
          } else if (now.getDay()==6) {
              // Samedi Ouvert entre 9h00 et 17h30
              return now>new Date(now.getFullYear(),now.getMonth(),now.getDate(),9,0) && now<new Date(now.getFullYear(),now.getMonth(),now.getDate(),17,30);
          } else {
              // Les autre jour entre 9h00 et 19h00
              return now>new Date(now.getFullYear(),now.getMonth(),now.getDate(),9,0) && now<new Date(now.getFullYear(),now.getMonth(),now.getDate(),19,0);
          }
        }
        catch(e) {
          console.warn("Error javascript in isCompletudeOpen.");
          return true;
        }
          
    };
    
    /**
     * Met à jour l'ensemble des champs corespondant à une agence sur la page ( Numéro de tel, lien vers page agence , horaires d'ouverture, ...)
     * @param {id de la nouvelle agence}
     */
    w.Completude.UpdateAgence = function(id) {
      
      if (id && id==="0") {// agence zero ( pour la visio) =  ne pas mettre à jour l'agence en cours
        return;
      }
          
      w.Completude.GetAgency(id).then(function(agency) {    
        // Mise à jour de la variable globale et du cookie                
        window.Completude.agence = agency; 
        
        // Déclenche l'évènement "agence"
        jQuery(document).trigger("agenceLoaded",[agency]);
        
        if (agency==null) {          
          // Pas d'agence
          // Masque les blocs liés à des champs agence
          jQuery("[data-agence-show]").each(function() {
            jQuery(this).hide();
          });
          jQuery("[data-agence-hide]").each(function() {
            jQuery(this).show();
          });
        } else {
          window.localStorage.setItem('agency_id', agency.Id); 
          window.sessionStorage.setItem('agence',JSON.stringify(agency));             
        }

        // Mise à jour des champs liés à une agence
        try {
          if (window.Completude.agence!=null) {

           window.localStorage.setItem('agency_id', window.Completude.agence.Id); 
           window.sessionStorage.setItem('agence',JSON.stringify(window.Completude.agence));             

            Object.assign(window.Completude.agence,{"PrefixAgence" : window.Completude.agence.AgencePhysique ?"Mon agence à":"Complétude à"});
            jQuery('body').mapObject(window.Completude.agence,"agence");

          }
        }  
        catch (e) {
          console.warn("Erreur in UpdateAgence Mise à jour champ agence") 
        }

        // Mise à jour du sticky mobile
        try {
          if (jQuery("#sticky_phone").length>0) {
            var ouvert = w.Completude.isCompletudeOpen(w.Completude.agence);          
            var btnrappel = jQuery("#sticky_phone .btn__rappel").length>0;
            var telheuresFermeture = jQuery("#sticky_phone").attr('data-actif-heures-fermeture')=="1";
            jQuery("#sticky_phone").show();
            if (ouvert) {
              // Affiche le bouton de tel
              jQuery("#sticky_phone .btn__phone").show();
              jQuery("#sticky_phone .btn__rappel").hide();
            } 
            else if (btnrappel && telheuresFermeture) {
              // Affiche le bouton de rappel.
              jQuery("#sticky_phone .btn__phone").hide();
              jQuery("#sticky_phone .btn__rappel").show();
            }
            else if (telheuresFermeture) {
              // Affiche le bouton de tel
              jQuery("#sticky_phone .btn__phone").show();
              jQuery("#sticky_phone .btn__rappel").hide();
            }
            else {
              jQuery("#sticky_phone").hide();
            }
          }
        }
        catch(e) {          
          console.info("Erreur in UpdateAgence Mise à jour sticky mobile"); 
        }
        
        // Mise à jour des Heures d'ouverture dans FormApply
        try {
          if ( jQuery('.OuvertOuProchainOuvertude').length > 0) {
            var now    = new Date(); 
            var ouvert = w.Completude.isCompletudeOpen(w.Completude.agence);
            
            if( now.getDate() != 0) {
              jQuery('.OuvertOuProchainOuvertude').html("Ouvert Aujourd'hui");
              
              if( jQuery('.OuvertSamedi').length > 0 || jQuery('.OuvertSemaine').length > 0 ) {
                if( now.getDate() == 6 ) {
                  jQuery('.OuvertSamedi').removeClass('hide');
                  jQuery('.OuvertSamedi').addClass('jsForceShow');
                }
                else {
                  jQuery('.OuvertSemaine').removeClass('hide');
                  jQuery('.OuvertSemaine').addClass('jsForceShow');
                }
              }
            }
            else {
              jQuery('.OuvertOuProchainOuvertude').html("Ouvert Demain");
            }
          }
        }
        catch(e) {          
          console.info("Erreur in UpdateAgence Mise à jour sticky mobile"); 
        }
        
      });
    };


    /**
     * Retourne un promise permettant d'obtenir la liste des matières
     */
    w.Completude.GetMatieres = function(classId) {
      return jQuery.ajax({
        url: disko_ajax_object.ajaxurl,
        type: 'get',
        data: {
            'action': 'wp_get_matieres',
            'IdClasse': classId
        }        
      }).promise();
    };
   
    /**
     *  TODO A Revoir  (inutile  ?)
     * 
     * Affiche une popup indiquant que Complétude ne dessert pas cette adresse
     */
    w.Completude.popupDeserved = function (domClasse = ".error-not-deserve") {
        if (typeof jQuery('#popup-error1-link') != typeof undefined) {
            //jQuery('#popup-error1-link').removeClass('hide');
            //jQuery('.form_disable_no_class').not('.no-hide').addClass('hide');
            jQuery(domClasse).show();
        }
        jQuery('[data-popup-link]').on('click', function () {
            window.tagManager(jQuery(this));
        });

    }

   
    /**
     * A partir de Completude.nouvelles_agences, renvoie True/False si l'ID 
     * passé en paramettre est une nouvelle agence
     */
    w.Completude.isNewAgence = function(id) {
      let r = false; // return var
      for (let index in Completude.settings.nouvelles_agences) {
        if(Completude.settings.nouvelles_agences[index] == id) {
          r = true;
        }
      }
      return r;
    }    
    
    /**
     * Load les Map Google
     */
    w.Completude.LoadGoogleMap = function() {
      if (jQuery(document).find('.google-map').length) {
          jQuery(document).find('.google-map').each(function () {
              console.log(jQuery(this));
              window.initMap(jQuery(this), null, null, null);
          });
      }
    }


    /**
     * Retourne true si l'utilisateur a déjà postulé false sinon
     */
    w.Completude.dejaPostule  = function() {
      var postuler =  w.Completude.GetStorage("form-postuler");
      return typeof(postuler)!=='undefined' && postuler!==null;
    }
    
    jQuery(function() {      
      // Charge les paramètres globaux
      w.Completude.GetGlobalQueryParameter();
      // Charge l'agence par défaut si necessaire
      w.Completude.UpdateAgence();   
      // Init des composants HTML 
      w.Completude.InitHtmlComponent();  
      // Init les map Google Map    
      w.Completude.LoadGoogleMap();
    })
  
})(window);

 





  

  

